exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___UMsih{transition:.5s}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___UMsih"
};